import { Component, OnInit } from '@angular/core';
import { AppTranslateService } from './core/internationalization/app-translate.service';
import { EnvironmentService } from './core/environment/environment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'cronoss';

  constructor(
    private appTranslate: AppTranslateService,
    private environmentService: EnvironmentService
  ) {
    this.appTranslate.setTranslateLanguageFromBrowser();
    void this.environmentService.initEnvironment();
  }

  ngOnInit(): void {
  }

}
